import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import CompactLayout from 'src/layouts/compact';
// components
import { SplashScreen } from 'src/components/loading-screen';
import SpeakAnimation from 'src/components/SpeakAnimation';
import TeamInvitePage from 'src/pages/team-invite';
import AccountCreatedSuccessPage from 'src/pages/team-invite/account-created-success';
import LinkExpiredPage from 'src/pages/team-invite/link-expired';
import RedirectPublicPage from 'src/sections/public-pages/redirect-public-page';
import PublicCandidateProfilePage from 'src/pages/public-candidate-profile';
import Page401 from 'src/pages/401';
import ChangePassword from 'src/pages/dashboard/change-password';
import SignupPage from 'src/pages/signup';

// ----------------------------------------------------------------------

const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    path: 'signup/invite',
    element: <SignupPage />,
  },
  {
    path: 'signup/expired',
    element: <LinkExpiredPage />,
  },
  {
    path: 'signup/success',
    element: <AccountCreatedSuccessPage />,
  },
  {
    path: 'team-invite/:orgId/:userId',
    element: <TeamInvitePage />,
  },
  {
    path: 'team-invite/:orgId/:userId/success',
    element: <AccountCreatedSuccessPage />,
  },
  {
    path: 'team-invite/:orgId/:userId/expired',
    element: <LinkExpiredPage />,
  },
  {
    path: 'job-candidate-public-profile/:candidateId',
    element: <PublicCandidateProfilePage />,
  },
  {
    element: (
      <CompactLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactLayout>
    ),
    children: [
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
      { path: '401', element: <Page401 /> },
      { path: 'change-password', element: <ChangePassword /> },
      { path: 'speak', element: <SpeakAnimation /> },
      {
        path: 'p/:id',
        element: <RedirectPublicPage />,
      },
    ],
  },
];
